// eslint-disable-next-line no-unused-vars
import React from 'react';
/** @jsx jsx */ import {
  Global,
  jsx
} from '@emotion/react'; /* Keep jsx import, see https://github.com/emotion-js/emotion/issues/1122 */
import { css } from 'twin.macro';
import PropTypes from 'prop-types';
import YesplanLogo from '../YesplanLogo';
import YesplanLocationUrlWrapper from '../YesplanLocationUrlWrapper';
import { Link } from '../../styled components/Typography';
import ErrorCodeText from './ErrorPage.style';
import WindowBorder from '../../styled components/WindowBorder';
import { NavigationVariants } from '../../libs/animations';
import WidgetPageContainerAnimation from '../WidgetPage/WidgetStyle.style';
import NavigationHistory from '../../libs/NavigationHistory';

const Image = (props) => (
  <p
    tw="text-silver-lighten-20"
    css={css`
      font-size: 70vw;
      font-weight: 700;
      text-align: center;
      line-height: 1;
      letter-spacing: 0.05rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      z-index: 0;
      @media (min-width: 1300px) {
        font-size: 40vw;
      }
    `}
    {...props}
  >
    {props.text}
  </p>
);

Image.propTypes = {
  text: PropTypes.string.isRequired
};

function messageForErrorCode(errorCode) {
  switch (errorCode) {
    case 403:
      return i18n('Access to Yesplan App forbidden');
    case 404:
      return i18n('Page not found');
    default:
      return '';
  }
}

/**
   ErrorPage can be triggered from the Root component or from Yesplan App frame.
   In the first case we miss some context, like domain, host and locale.
   In that case we can't provide a Link back to the home page and we use English as a fallback locale.
 */
const ErrorPage = ({
  errorCode = 404,
  match = null,
  navigationHistory = null,
  linkUrlFor,
  clientErrorMessage = ''
}) => (
  <WidgetPageContainerAnimation
    initial="visible"
    exit="moveOutRight"
    animate="visible"
    variants={NavigationVariants}
  >
    {/* Specific html styling for this page.
     * Avoid horizontal scrollbar caused by Image404 component */}
    <Global
      styles={css`
        html {
          overflow: hidden;
        }
      `}
    />
    {clientErrorMessage.length ? (
      <Image text="Ø" />
    ) : (
      <Image text={errorCode.toString()} />
    )}

    <div
      css={css`
        z-index: 1;
        position: relative;
        text-align: center;
        max-width: 800px;
        margin: 25vh auto 0;
        padding: 0 5%;
      `}
    >
      <YesplanLogo
        css={css`
          max-width: 280px;
          margin: 0 auto;
        `}
      />
      <ErrorCodeText>
        <span role="img" aria-label="">
          🤔
        </span>
        <br />
        {clientErrorMessage.length ? clientErrorMessage : messageForErrorCode(errorCode)}
      </ErrorCodeText>
      {match && match.params && match.params.domain && (
        <Link
          onClick={() => {
            navigationHistory.goTo(linkUrlFor('/'));
          }}
        >
          {i18n('Go to Homepage')}
        </Link>
      )}
    </div>
    <WindowBorder />
  </WidgetPageContainerAnimation>
);

ErrorPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      domain: PropTypes.string
    })
  }),
  errorCode: PropTypes.number,
  clientErrorMessage: PropTypes.string,
  navigationHistory: PropTypes.instanceOf(NavigationHistory),
  linkUrlFor: PropTypes.func
};

const wrapper = function (props) {
  if (props.match) {
    return (
      <YesplanLocationUrlWrapper {...props}>
        <ErrorPage {...props} />
      </YesplanLocationUrlWrapper>
    );
  }
  return <ErrorPage {...props} />;
};

export default wrapper;
